import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, Col, Collapse, Modal, notification, Radio, Row, Tooltip } from "antd";
import { useLocations } from '../CityProvinceManagement/connectApi/location';
import MapWithSingleMarker from '../../components/Map/MapWithSingleMarker';
// import FormatPrice from '../../components/FormatPrice/FormatPricw';
import Num2persian from 'num2persian';
import { useOrders } from './connectApi/createOrder';
// import { Title } from 'ckeditor5';
import ConvertPersianToEnglish from '../../components/ConvertNumberToEnglish';
import { useSubscriptions } from '../Subscriptions/fetchApi';
import ImageUploadComponent from '../../components/Ads/ImageUploadComponent';

export default function CreateAd() {
    const formErrors = useState([])
    const { getDetailsOrders, getAdsCommnetByMasterId, getAdsPicMasterByMasterPriorityId, deleteAdsMaster, editAdsMasterRegisterStatus, getRejectionnReasons, getAdsMasterByPhoneNumber, getDetailMasterByQuery } = useOrders((state) => state.actions);
    const responseFromAdsMasterByPhoneNumber = useOrders((state) => state.responseFromAdsMasterByPhoneNumber);
    const cityByParentId = useLocations((state) => state.cityByParentId)
    const { getAllProvinces } = useLocations((state) => state.actions)

    const [mp4Count, setMp4Count] = useState(0);
    const [img1, setImg1] = useState("/icons/Frame79.svg");
    const [img1Binary, setImg1Binary] = useState();
    const [img2, setImg2] = useState(
        // localStorage.getItem("img2")
        //     ? localStorage.getItem("img2")
        //     : "/icons/Frame79.svg"
        "/icons/Frame79.svg"
    );
    const [img2Binary, setImg2Binary] = useState();
    const [img3, setImg3] = useState("/icons/Frame79.svg");
    const [img3Binary, setImg3Binary] = useState();
    const [img4, setImg4] = useState("/icons/Frame79.svg");
    const [img4Binary, setImg4Binary] = useState();
    const [img5, setImg5] = useState("/icons/Frame79.svg");
    const [img5Binary, setImg5Binary] = useState();
    const [img6, setImg6] = useState("/icons/Frame79.svg");
    const [img6Binary, setImg6Binary] = useState();
    const [img7, setImg7] = useState("/icons/Frame79.svg");
    const [img7Binary, setImg7Binary] = useState();
    const [img8, setImg8] = useState("/icons/Frame79.svg");
    const [img8Binary, setImg8Binary] = useState();
    const [img9, setImg9] = useState("/icons/Frame79.svg");
    const [img9Binary, setImg9Binary] = useState();
    const [imgList, setImgList] = useState([]);
    const [selectedAreaName, setSelectedAreaName] = useState(['']);
    const [noPhonenumberError, setNoPhonenumberError] = useState(false);
    const [longPhonenumberError, setLongPhonenumberError] = useState(false);
    const [noTitleError, setNoTitleError] = useState(false);
    const [noPrptyTradeTypeCodeError, setNoPrptyTradeTypeCodeError] = useState(false);
    const [noAdsPrptyTypeCodeError, setNoAdsPrptyTypeCodeError] = useState(false);
    // const [noAreaError, setNoAreaError] = useState(false);
    const [noMetrageError, setNoMetrageError] = useState(false);
    const [noPropertyLandMetarageError, setNoPropertyLandMetarageError] = useState(false);
    const [abilityToConvertError, setAbilityToConvertError] = useState(false);
    const [selectedCity, setSelectedCity] = useState(0)
    const [selectedProvince, setSelectedProvince] = useState(0)
    const [areaCenterLatitude, setAreaCenterLatitude] = useState(null)
    const [areaCenterLongitude, setAreaCenterLongitude] = useState(null)
    const [phoneNumbers, setPhoneNumbers] = useState([]); // List of phone numbers
    const [parcelNumber, setParcelNumber] = useState(null)
    const [isAdsDetailVisible, setIsAdsDetailVisible] = useState(false)
    const [buildingOrientation, setBuildingOrientation] = useState("")
    const [floorMaterial, setFloorMaterial] = useState("")
    const [bathroomType, setBathroomType] = useState("")
    const [coolingSystem, setCoolingSystem] = useState("")
    const [heatingSystem, setHeatingSystem] = useState("")
    const [waterHeaterType, setWaterHeaterType] = useState("")
    const [deed, setDeed] = useState("")
    const [isRenovated, setIsRenovated] = useState(false)
    const [isProvinceCityLocked, setIsProvinceCityLocked] = useState(false);
    const [lockedLocation, setLockedLocation] = useState({
        provinceId: null,
        cityId: null,
    });
    const [chooseProvinceAndCityError, setChooseProvinceAndCityError] = useState(false)
    const [chooseLockedCategoryTradeTypeError, setChooseLockedCategoryTradeTypeError] = useState(false)
    const [isCategoryTradeTypeLocked, setIsCategoryTradeTypeLocked] = useState(false);
    const [lockedCategoryTradeType, setLockedCategoryTradeType] = useState({
        adsMainCategoryCode: null,
        adsPrptyTradeTypeCode: null,
        adsPrptyTypeCode: null,
    });
    const [searchProvince, setSearchProvince] = useState("");
    const [searchCity, setSearchCity] = useState("");

    const openNotification = () => {
        notification.open({
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                    />
                </svg>
            ),
            message: "اخطار",
            description: "3 تا ویدئو بیشتر انتخاب نکن",
        });
    };

    function FormatPrice(price) {
        if (!price) return "";
        const priceString = price.toString();
        return priceString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function convertPersianToEnglish(num) {
        const persianMap = {
            "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
            "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
            "٬": "," // Add Persian comma to English comma mapping
        };
        return num.replace(/[۰-۹٬]/g, (match) => persianMap[match] || match);
    }

    // const handleCityChange = (e) => {
    //     // console.log(e?.target.value, " e e  e e e 22222222");
    //     // setSelectedCity(e?.target.value)
    //     // getLocationByParentId(e?.target.value)
    //     // const city = cityByParentId.find(city => city.id === e?.target.value)
    //     // setAreaCenterLatitude(city?.centerLatitude)
    //     // setAreaCenterLongitude(city?.centerLongitude)
    //     const cityId = e?.target.value;
    //     setSelectedCity(cityId);
    //     const city = cityByParentId.find((city) => city.id === cityId);
    //     if (city) {
    //         setAreaCenterLatitude(city.centerLatitude);
    //         setAreaCenterLongitude(city.centerLongitude);
    //     }
    //     setSelectedAreaId(null); // Reset area when city changes
    //     getLocationByParentId(cityId); // Fetch areas for the selected city
    // }
    // const handleProvinceChange = (e) => {
    //     // console.log(e?.target.value, " e e  e e e 22222222");
    //     // setSelectedProvince(e?.target.value)
    //     // getOneCity(e?.target?.value)
    //     const provinceId = e?.target.value;
    //     setSelectedProvince(provinceId);
    //     const province = provinceByParentId.find((prov) => prov.id === provinceId);
    //     if (province) {
    //         setAreaCenterLatitude(province.centerLatitude);
    //         setAreaCenterLongitude(province.centerLongitude);
    //     }
    //     setSelectedCity(0); // Reset city when province changes
    //     setSelectedAreaId(null); // Reset area when province changes
    //     getOneCity(provinceId); // Assuming this fetches cities for the selected province
    // }

    const handleProvinceChange = (e) => {
        const provinceId = e?.target.value;

        if (isProvinceCityLocked) return; // Prevent change if locked

        setSelectedProvince(provinceId);
        const province = provinceByParentId.find((prov) => prov.id === provinceId);
        if (province) {
            setAreaCenterLatitude(province.centerLatitude);
            setAreaCenterLongitude(province.centerLongitude);
        }

        setSelectedCity(0);
        setSelectedAreaId(null);
        getOneCity(provinceId);

        // Save current province if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                provinceId,
            }));
        }
    };

    const handleCityChange = (e) => {
        const cityId = e?.target.value;

        if (isProvinceCityLocked) return; // Prevent change if locked
        setChooseProvinceAndCityError(false)
        setSelectedCity(cityId);
        const city = cityByParentId.find((city) => city.id === cityId);
        if (city) {
            setAreaCenterLatitude(city.centerLatitude);
            setAreaCenterLongitude(city.centerLongitude);
        }

        setSelectedAreaId(null);
        getLocationByParentId(cityId);

        // Save current city if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                cityId,
            }));
        }
    };
    useEffect(() => {




        phoneNumbers[0] && getAdsMasterByPhoneNumber(phoneNumbers[0])
        phoneNumbers[1] && getAdsMasterByPhoneNumber(phoneNumbers[1])
    }, [phoneNumbers])
    useEffect(() => {
        const savedLockState = localStorage.getItem('isProvinceCityLocked') === 'true';
        const savedLocation = JSON.parse(localStorage.getItem('lockedLocation'));

        setIsProvinceCityLocked(savedLockState);

        if (savedLockState && savedLocation) {
            setLockedLocation(savedLocation);
            // Optionally restore UI state like selectedProvince, selectedCity
            setSelectedProvince(savedLocation.provinceId);
            setSelectedCity(savedLocation.cityId);

            // If needed: fetch city data based on province, center coordinates, etc.
            if (savedLocation.provinceId) getOneCity(savedLocation.provinceId);
            if (savedLocation.cityId) getLocationByParentId(savedLocation.cityId);
        }
    }, []);
    useEffect(() => {
        if (isProvinceCityLocked) {
            const newLockedLocation = {
                provinceId: selectedProvince,
                cityId: selectedCity,
            };
            setLockedLocation(newLockedLocation);
            localStorage.setItem('lockedLocation', JSON.stringify(newLockedLocation));
        }
    }, [selectedProvince, selectedCity, isProvinceCityLocked]);
    const adsPrptyTradeTypeCodes = {
        1: "فروش",
        2: "رهن و اجاره",
        3: "معاوضه",
        4: "مشارکت در ساخت",
        5: "پیش فروش",
        6: "رهن و اجاره کوتاه مدت",
        7: "متقاضی خرید",
        8: "متقاضی اجاره",
    }
    const propertyTypes = {
        1: "آپارتمان مسکونی",
        2: "آپارتمان اداری",
        3: "خانه و ویلا",
        4: "زمین کلنگی",
        5: "مستغلات",
        6: "مغازه",
        7: "صنعتی و کشاورزی",
    };
    const categoryMap = {
        1: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 9, 7: 10, 8: 11 }, // adsPrprtyType: 1
        2: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 1, 7: 10, 8: 11 }, // adsPrprtyType: 2
        3: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        4: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: null, 7: 10, 8: 11 },
        5: { 1: 6, 2: 7, 3: 6, 4: 8, 5: 6, 6: null, 7: 10, 8: 11 },
        6: { 1: 3, 2: 4, 3: 3, 4: 8, 5: 3, 6: null, 7: 10, 8: 11 },
        7: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        // Add other adsPrprtyType and adsPrprtyTradeType mappings here
    };
    function getAdsPrprtyCategory(adsPrprtyType, adsPrprtyTradeType) {
        return categoryMap[adsPrprtyType]?.[adsPrprtyTradeType] ?? null; // Default to null if not found
    }
    const areas = useLocations((state) => state.areas)
    const { getLocationByParentId } = useLocations((state) => state.actions)
    const { getUserInit } = useSubscriptions((state) => state.actions)
    const userInit = useSubscriptions((state) => state.userInit)
    const { addOrder, addOrderDetails, saveOrderImg, addsPrptyAuction, postEditAdsDetail, addPhoneNumbers, addPropertyApplicantRentBuy } = useOrders((state) => state.actions)
    const masterCode = useOrders((state) => state.masterCode)
    const collapseRef = useRef(null);
    const [activeKey, setActiveKey] = useState(['']);
    const [selectedAreaId, setSelectedAreaId] = useState(null);
    const [selectedCityId, setSelectedCityId] = useState(null);
    const [selectedProvinceId, setSelectedProvinceId] = useState(null);
    const [areaList, setAreaList] = useState(areas)
    const [adsMainCategoryCode, setAdsMainCategoryCode] = useState(1)
    const [addedBy, setAddedBy] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCoordinates, setSelectedCoordinates] = useState(null);
    const [adsTitle, setAdsTitle] = useState("");
    const [newPhoneNumber, setNewPhoneNumber] = useState(""); // For adding/editing 

    const [editIndex, setEditIndex] = useState(null); // Track which number is being edited
    const [adsPrptyTradeTypeCode, setAdsPrptyTradeTypeCode] = useState(null)
    const [adsPrptyTypeCode, setAdsPrptyTypeCode] = useState(null)
    const [adsPrptyCategoryCode, setAdsPrptyCategoryCode] = useState(null)
    const [pricePerMeter, setPricePerMeter] = useState(null)
    const [totalPrice, setTotalPrice] = useState(null)
    const [metrage, setMetrage] = useState(null)
    const [numberOfRooms, setNumberOfRooms] = useState(null)
    const [lifeOfTheBuilding, setLifeOfTheBuilding] = useState(null)
    const [floorTo, setFloorTo] = useState(null)
    const [floorFrom, setFloorFrom] = useState(null)
    const [unitPerFloor, setUnitPerFloor] = useState(null)
    const [parking, setParking] = useState(false)
    const [basement, setBasement] = useState(false)
    const [elevator, setElevator] = useState(false)
    const [isApproximateArea, setIsApproximateArea] = useState(null);
    const [deposit, setDeposit] = useState(null);
    const [rent, setRent] = useState(null);
    const [convertingDepositAmount, setConvertingDepositAmount] = useState(null);
    const [convertingRentAmount, setConvertingRentAmount] = useState(null);
    const [abilityToConvert, setAbilityToConvert] = useState(false)
    const [propertyLandMetarage, setPropertyLandMetarage] = useState(null)
    const [squareFootageEntireProperty, setSquareFootageEntireProperty] = useState(null)
    const [propertyWidth, setPropertyWidth] = useState(null)
    const [buyPriceFrom, setBuyPriceFrom] = useState(null)
    const [buyPriceTo, setBuyPriceTo] = useState(null)
    const [metrageFrom, setMetrageFrom] = useState(null)
    const [meterageTo, setMeterageTo] = useState(null)
    const [lifeOfBuildingFrom, setLifeOfTheBuildingFrom] = useState(null)
    const [lifeOfBulidingTo, setLifeOfTheBuildingTo] = useState(null)
    const [rentPriceFrom, setRentPriceFrom] = useState(null)
    const [rentPriceTo, setRentPriceTo] = useState(null)
    const [rentDepositFrom, setRentDepositFrom] = useState(null)
    const [rentDepositTo, setRentDepositTo] = useState(null)
    const [address, setAddress] = useState(null)
    const [fullName, setFullName] = useState(null)
    const [description, setDescription] = useState(null)
    const [balcony, setBalcony] = useState(false)
    const [officialDeed, setOfficialDeed] = useState(false)
    const { getOneCity, getOneProvince } = useLocations((state) => state.actions)
    const provinceByParentId = useLocations((state) => state.provinceByParentId)


    useEffect(() => {
        if (areas.length) {
            setAreaList(areas)
        }
        // else {
        //     getLocationByParentId(3)
        // }

    }, [areas]);

    useEffect(() => {

        getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode)
        setAdsPrptyCategoryCode(getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode))
        setAbilityToConvert(false)
    }, [adsPrptyTypeCode, adsPrptyTradeTypeCode])

    useEffect(() => {
        getUserInit(localStorage.getItem("pelakUserId"))
        getOneProvince(1)

        const isLocked = localStorage.getItem('isCategoryTradeTypeLocked') === 'true';
        const savedData = JSON.parse(localStorage.getItem('lockedCategoryTradeType'));

        setIsCategoryTradeTypeLocked(isLocked);

        if (isLocked && savedData) {
            setLockedCategoryTradeType(savedData);
            setAdsMainCategoryCode(savedData.adsMainCategoryCode);
            setAdsPrptyTradeTypeCode(savedData.adsPrptyTradeTypeCode);
            setAdsPrptyTypeCode(savedData.adsPrptyTypeCode);
        }
    }, [])
    useEffect(() => {
        if (userInit) {
            if (!provinceByParentId?.length) {


                getOneProvince(1)
            }
            // getOneCity(userInit?.state)



            // getOneCity(2)
            // const z = provinceByParentId?.find((pro) => pro?.id === userInit?.state)

            // setAreaCenterLatitude(z?.centerLatitude)
            // setAreaCenterLongitude(z?.centerLongitude)
            if (areas.length) {
                setAreaList(areas)
            } else {
                getLocationByParentId(userInit?.city)
            }
        }
    }, [userInit])

    console.log({ cityByParentId });


    useEffect(() => {
        const z = provinceByParentId?.find((pro) => pro?.id === userInit?.state)
        setAreaCenterLatitude(z?.centerLatitude)
        setAreaCenterLongitude(z?.centerLongitude)
    }, [provinceByParentId])
    useEffect(() => {
        if (isCategoryTradeTypeLocked) {
            const newData = {
                adsMainCategoryCode,
                adsPrptyTradeTypeCode,
                adsPrptyTypeCode,
            };
            setLockedCategoryTradeType(newData);
            localStorage.setItem('lockedCategoryTradeType', JSON.stringify(newData));
        }
    }, [adsMainCategoryCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, isCategoryTradeTypeLocked]);

    // const provincesCollapse = [
    //     {
    //         key: '23',
    //         label: `استان ${selectedProvince !== 0 && provinceByParentId.find(c => c.id === selectedProvince)?.locName ?
    //             `/${provinceByParentId.find(c => c.id === selectedProvince)?.locName}` : ''}`,
    //         children: (
    //             <div className="flex flex-col space-y-4">
    //                 <Radio.Group

    //                     onChange={handleProvinceChange}
    //                     className="flex flex-col"
    //                 >
    //                     {provinceByParentId.map((province) => (
    //                         <Radio key={province.id} value={province.id}>
    //                             {province.locName}
    //                         </Radio>
    //                     ))}
    //                 </Radio.Group>
    //             </div>),
    //         disabled: isProvinceCityLocked,
    //     }
    // ]
    const filteredProvinces = provinceByParentId.filter((province) =>
        province.locName.includes(searchProvince)
    );
    const filteredCities = cityByParentId.filter((city) =>
        city.locName.includes(searchCity)
    );
    const provincesCollapse = [
        {
            key: '23',
            label: `استان ${selectedProvince !== 0 && provinceByParentId.find(c => c.id === selectedProvince)?.locName ?
                `/${provinceByParentId.find(c => c.id === selectedProvince)?.locName}` : ''}`,
            children: (
                <div className="flex flex-col space-y-4">
                    {/* Search input */}
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        className="flex items-center bg-gray-100 p-2 rounded"
                    >
                        <input
                            type="text"
                            value={searchProvince}
                            onChange={(e) => setSearchProvince(e.target.value)}
                            placeholder="جست‌وجوی استان"
                            className="w-full bg-transparent outline-none border-none"
                        />
                        <button type="submit">
                            <img src="/icons/search.svg" alt="جست و جو" />
                        </button>
                    </form>

                    {/* Filtered list of provinces */}
                    <Radio.Group onChange={handleProvinceChange} className="flex flex-col">
                        {filteredProvinces.map((province) => (
                            <Radio key={province.id} value={province.id}>
                                {province.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
            ),
            disabled: isProvinceCityLocked,
        }
    ];
    // const citiesCollapse = [
    //     {
    //         key: '22',
    //         label: `شهر ${selectedCity !== 0 && cityByParentId.find(c => c.id === selectedCity)?.locName ?
    //             `/${cityByParentId.find(c => c.id === selectedCity)?.locName}` : ''}`,
    //         children: (
    //             <div className="flex flex-col space-y-4">
    //                 <Radio.Group

    //                     onChange={handleCityChange}
    //                     className="flex flex-col"
    //                 >
    //                     {cityByParentId.map((city) => (
    //                         <Radio key={city.id} value={city.id}>
    //                             {city.locName}
    //                         </Radio>
    //                     ))}
    //                 </Radio.Group>
    //             </div>)
    //     }
    // ]
    const citiesCollapse = [
        {
            key: '22',
            label: `شهر ${selectedCity !== 0 && cityByParentId.find(c => c.id === selectedCity)?.locName ?
                `/${cityByParentId.find(c => c.id === selectedCity)?.locName}` : ''}`,
            children: (
                <div className="flex flex-col space-y-4">
                    {/* Search Input */}
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        className="flex items-center bg-gray-100 p-2 rounded"
                    >
                        <input
                            type="text"
                            value={searchCity}
                            onChange={(e) => setSearchCity(e.target.value)}
                            placeholder="جست‌وجوی شهر"
                            className="w-full bg-transparent outline-none border-none"
                        />
                        <button type="submit">
                            <img src="/icons/search.svg" alt="جست و جو" />
                        </button>
                    </form>

                    {/* Filtered City List */}
                    <Radio.Group onChange={handleCityChange} className="flex flex-col">
                        {filteredCities.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
            ),
        },
    ];



    const handleSelectDistrict = (selectedDistrictId) => {
        setSelectedAreaId(selectedDistrictId); // Set the selected district ID
    };
    const handleKeyPress2 = (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && collapseRef.current) {
            // Programmatically trigger a click on the Collapse header
            collapseRef.current.click();
            event.preventDefault();
        }
    }
    const handleCategoryChange = (value) => {
        if (isCategoryTradeTypeLocked) return;
        if (value === 2)
            setAdsMainCategoryCode(8)

        if (value === 3) {
            setAddedBy(1)
            setAdsMainCategoryCode(1)
        }

        setActiveKey([]);


        // یک برای کاربرسایت دو برای کرالر و سه برای ادمین
    }
    const handleOpenModal = () => {
        setIsModalVisible(true); // Show modal
    };

    const handleCloseModal = () => {
        setIsModalVisible(false); // Close modal
        setActiveKey(null);
    };
    const handleMapClick = (coords) => {
        setSelectedCoordinates(coords);

    };
    const handleAdsTitleChange = (value) => {
        setAdsTitle(value)
    }
    const handleMobilePhoneChange = (value) => {
        setNoPhonenumberError(false)
        const convertedValue = ConvertPersianToEnglish(value);
        const sanitizedValue = convertedValue.replace(/\D/g, ""); // Remove non-numeric characters
        if (sanitizedValue?.length > 11) {
            setLongPhonenumberError(true)
        } else {
            setLongPhonenumberError(false)
        }
        setNewPhoneNumber(sanitizedValue);
    }
    const handleAddPhoneNumber = () => {
        if (newPhoneNumber.trim() !== "") {
            setNoPhonenumberError(false)
            // Add the new phone number if valid
            setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
            setNewPhoneNumber(""); // Reset input
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleAddPhoneNumber();
        }
    }
    const handleEditPhoneNumber = (index, value) => {

        const updatedNumbers = [...phoneNumbers];

        updatedNumbers[index] = value;
        // Update the specific number
        setPhoneNumbers(updatedNumbers);
    };

    const handleRemovePhoneNumber = (index) => {
        const updatedNumbers = phoneNumbers.filter((_, i) => i !== index);
        setPhoneNumbers(updatedNumbers); // Remove the specific number
    };
    const handleSubmit = async () => {
        if (!phoneNumbers.length) {
            setNoPhonenumberError(true)
            formErrors.push("تلفن را وارد نمایید.")
        }
        // else if (!selectedAreaId) {
        //     setNoAreaError(true)
        // }
        else if (adsTitle === "") {
            setNoTitleError(true)
            
            formErrors.push("عنوان آگهی را وارد نمایید.")
        }
        else if (!adsPrptyTradeTypeCode) {
            setNoPrptyTradeTypeCodeError(true)
            formErrors.push("نوع معامله را انتخاب کنید.")
        }
        else if (!adsPrptyTypeCode) {
            setNoAdsPrptyTypeCodeError(true)
            formErrors.push("نوع ملک را انتخاب کنید.")
        }
        else if (abilityToConvert && (!convertingDepositAmount || convertingDepositAmount === "" || !convertingRentAmount || convertingRentAmount === "")) {
            setAbilityToConvertError(true)
            formErrors.push("مقادیر مربوط به تبدیل ودیعه و اجاره را وارد کنید.")
        }
        else if ((adsPrptyCategoryCode === 8 || adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 4) && (!metrage || metrage === 0)) {
            setNoMetrageError(true)
            formErrors.push("متراژ را وارد کنید.")
        } else if ((adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) && (!propertyLandMetarage || propertyLandMetarage === 0)) {
            setNoPropertyLandMetarageError(true)
            formErrors.push("متراژ را وارد کنید.")
        }


        else {




            await addOrder(
            /* id */ 0,
            /* usruserCode */0,
            /* adsMainCategoryCode */ adsMainCategoryCode,
           /*  adsAdvertiseShowTypeCode */ 0,
           /* countryCode */1,
           /* "stateCode" */ selectedProvince,
          /*  "cityCode" */selectedCity,
          /*  "areaCode" */ selectedAreaId,
                selectedCoordinates ? selectedCoordinates[0] : null,
                selectedCoordinates ? selectedCoordinates[1] : null,
          /* selectedCoordinates[1] ?    selectedCoordinates[1]:0  */
                // selectedCoordinates[1]??null,
          /* isApproximateArea */isApproximateArea,
                adsTitle,

                phoneNumbers[0],
            /* landPhone */null,
            /* price */null,
            /* description */ description,
                null,
                null,
                null,
                fullName,
                address,
                isRenovated,
                balcony,
                officialDeed,
                buildingOrientation,
                floorMaterial,
                bathroomType,
                coolingSystem,
                heatingSystem,
                waterHeaterType,
                deed,
                parcelNumber
            )
        }


        // if (masterCode) {
        //     console.log("inside iffff");

        //     await addOrderDetails(
        //         0,  // id,
        //         masterCode,  // adsMasterCode,
        //         adsPrptyCategoryCode,  // adsPrptyCategoryCode,
        //         Number(adsPrptyTradeTypeCode), // adsPrptyTradeTypeCode,
        //         adsPrptyTypeCode,  // adsPrptyTypeCode,
        //         null, // adsAdvertiseTypeCode,
        //         Number(pricePerMeter), // pricePerMeter,
        //         Number(totalPrice), // totalPrice,
        //         propertyLandMetarage,  // propertyLandMetarage,
        //         propertyWidth, // propertyWidth,
        //         deposit, // deposit,
        //         rent, // rentPerMonth,
        //         abilityToConvert, // abilityToConvert,
        //         convertingDepositAmount, // convertingDepositAmount,
        //         convertingRentAmount,// convertingRentAmount,
        //         Number(metrage), // meterage,
        //         Number(numberOfRooms), // numberOfRooms,
        //         Number(lifeOfTheBuilding), // lifeOfTheBuilding,
        //         null, // dateForRent,
        //         Number(floorFrom),  // floorNumber,
        //         Number(floorTo), // totalFloor,
        //         Number(unitPerFloor), // unitPerFloor,
        //         parking, // parking,
        //         basement, // basement,
        //         elevator,  // elevator,
        //         description, // description, 26
        //     )
        // }


    }

    const onSubmitWithMasterCode = async () => {






        if (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) {
            addPropertyApplicantRentBuy(
                0,
                adsPrptyTradeTypeCode,
                masterCode,
                adsPrptyTypeCode,
                adsPrptyCategoryCode === 10 ? 10 : 11,
                buyPriceFrom,
                buyPriceTo,
                rentDepositFrom,
                rentDepositTo,
                rentPriceFrom,
                rentPriceTo,
                metrageFrom,
                meterageTo,
                lifeOfBuildingFrom,
                lifeOfBulidingTo,
                description


            )
        } else {

            await addOrderDetails(
                0,  // id,
                masterCode,  // adsMasterCode,
                adsPrptyCategoryCode,  // adsPrptyCategoryCode,
                Number(adsPrptyTradeTypeCode), // adsPrptyTradeTypeCode,
                adsPrptyTypeCode,  // adsPrptyTypeCode,
                null, // adsAdvertiseTypeCode,
                Number(pricePerMeter), // pricePerMeter,
                Number(totalPrice), // totalPrice,
                propertyLandMetarage,  // propertyLandMetarage,
                propertyWidth, // propertyWidth,
                deposit, // deposit,
                rent, // rentPerMonth,
                abilityToConvert, // abilityToConvert,
                convertingDepositAmount, // convertingDepositAmount,
                convertingRentAmount,// convertingRentAmount,
                Number(metrage), // meterage,
                Number(numberOfRooms), // numberOfRooms,
                Number(lifeOfTheBuilding), // lifeOfTheBuilding,
                null, // dateForRent,
                Number(floorFrom),  // floorNumber,
                Number(floorTo), // totalFloor,
                Number(unitPerFloor), // unitPerFloor,
                parking, // parking,
                basement, // basement,
                elevator,  // elevator,
                description, // description, 26
            )

        }

        await addPhoneNumbers(
            masterCode,
            phoneNumbers ?? [])

        imgList?.map((imageFile, index) => {
            saveOrderImg(
                masterCode,
                imageFile,
                index + 1,
            )

        })

        setSelectedAreaId(null)
        setAdsMainCategoryCode(null)
        setAdsPrptyTradeTypeCode(null)
        setAdsPrptyTypeCode(null)
        setAdsTitle("")
        setFullName("")
        setPhoneNumbers([])
        setAddress(null)
        setSelectedAreaName("")
        setSelectedCoordinates([])
        setSelectedCoordinates(null)
        setElevator(false)
        setBasement(false)
        setParking(false)
        setIsApproximateArea(false)
        setAddress("")
        setDescription("")
        setDeposit(null)
        setRent(null)
        setTotalPrice(null)
        setPricePerMeter(null)
        setPricePerMeter(null)
        setBuyPriceTo(null)
        setBuyPriceFrom(null)
        setUnitPerFloor(null)
        setFloorTo(null)
        setFloorFrom(null)
        setLifeOfTheBuilding(null)
        setPropertyWidth(null)
        setMetrage(null)
        setSquareFootageEntireProperty(null)
        setPropertyLandMetarage(null)
        setConvertingRentAmount(null)
        setConvertingDepositAmount(null)
        setDeposit(null)
        setRent(null)
        setNumberOfRooms(null)
        setLifeOfTheBuildingTo(null)
        setLifeOfTheBuildingFrom(null)
        setMeterageTo(null)
        setMetrageFrom(null)
        setRentPriceTo(null)
        setRentPriceFrom(null)
        setRentDepositTo(null)
        setRentDepositFrom(null)
        setImgList([])

        setImg9("/icons/Frame79.svg")
        setImg8("/icons/Frame79.svg")
        setImg7("/icons/Frame79.svg")
        setImg6("/icons/Frame79.svg")
        setImg5("/icons/Frame79.svg")
        setImg4("/icons/Frame79.svg")
        setImg3("/icons/Frame79.svg")
        setImg2("/icons/Frame79.svg")
        setImg1("/icons/Frame79.svg")

    }

    useEffect(() => {


        if (masterCode) {
            onSubmitWithMasterCode()
        }
    }, [masterCode])


    const districtsCollapse = [
        {
            key: '4',
            label: `محله /${selectedAreaName}`,
            children: (
                <div className='flex items-center justify-around w-full gap-4 '>
                    <div>
                        <form>
                            <div className='flex items-center bg-gray-100 p-2 rounded '>
                                <input
                                    onChange={async (e) => {
                                        setAreaList(areas.filter(area => area.locName.includes(e.target.value)));

                                    }}
                                    className='w-full bg-transparent outline-none border-none'
                                    type="text"
                                    placeholder="نام محله"
                                />
                                <button type='submit'>
                                    <img src="/icons/search.svg" alt="جست و جو" />
                                </button>
                            </div>
                        </form>
                        <div className="h-[300px] overflow-y-scroll overflow-x-hidden border-r border-l border-b rounded p-2 w-full z-50">
                            {areaList && areaList.map(area => (
                                <Radio
                                    key={area.id}
                                    value={area.id}
                                    checked={selectedAreaId === area.id} // Assuming selectedAreaId is a single selected district
                                    onChange={() => {
                                        handleSelectDistrict(area.id)
                                        setActiveKey([])
                                        setSelectedAreaName(area?.locName)
                                        // setNoAreaError(false)

                                    }} // handleSelectDistrict will set the selected district ID
                                    className="my-2 py-1 border-b hover:bg-gray-100 transition-all w-full"
                                >
                                    <p className="font-bold">{area.locName}</p>
                                    <p className="text-sm text-gray-800">{area.subAreas?.map((item, index) => index === area.subAreas?.length - 1 ? item : `${item}  ،`)}</p>

                                </Radio>
                            ))}
                        </div>
                    </div>
                </div>
            ),
        },
    ];
    const categoriesCollapse = [
        {
            key: '1',
            label: ` دسته بندی /${adsMainCategoryCode !== 8 ? `شخصی` : `تعاون`}  `,
            children:
                <Radio.Group
                    onChange={(e) => handleCategoryChange(e.target.value)}
                    value={adsMainCategoryCode === 8 ? 2 : 3}
                    className='flex flex-col rtyr'>
                    <Radio value={2} > تعاون</Radio >
                    <Radio value={3} >شخصی </Radio >
                </Radio.Group>
        },
    ];

    ;

    const openModal = [
        {
            key: '2',
            label: (
                <span onClick={() => handleOpenModal()}>انتخاب موقعیت مکانی از روی نقشه</span>
            ),

        },
    ];

    const adsPrptyTradeTypeCodeCollapse = [
        {
            key: '2',
            label: ` نوع معامله   ${adsPrptyTradeTypeCode ? `/` + adsPrptyTradeTypeCodes[adsPrptyTradeTypeCode] : ``} `,
            children:
                <Radio.Group
                    onChange={(e) => {
                        if (isCategoryTradeTypeLocked) return;
                        setAdsPrptyTradeTypeCode(e.target.value)
                        setActiveKey([])
                        setNoPrptyTradeTypeCodeError(false)
                    }

                    } value={adsPrptyTradeTypeCode}
                    className={`flex flex-col `}>
                    <Radio value={1} >فروش</Radio >
                    <Radio value={2} >رهن و اجاره</Radio >
                    <Radio value={3} >معاوضه</Radio >
                    <Radio value={4} >مشارکت در ساخت</Radio >
                    <Radio value={5} >پیش فروش</Radio >
                    <Radio value={6} >رهن و اجاره کوتاه مدت</Radio >
                    <Radio value={7} >متقاضی خرید</Radio >
                    <Radio value={8} >متقاضی اجاره</Radio >
                </Radio.Group>
        },
    ];
    const adsPrptyTypeCodeCollapse = [
        {
            key: '3',
            label: ` نوع ملک ${adsPrptyTypeCode ? `/` + propertyTypes[adsPrptyTypeCode] : ``}`,
            children:
                <Radio.Group
                    onChange={(e) => {
                        if (isCategoryTradeTypeLocked) return;

                        setNoAdsPrptyTypeCodeError(false)
                        setAdsPrptyTypeCode(e.target.value)
                        setActiveKey([])
                        setChooseLockedCategoryTradeTypeError(false)
                    }

                    } value={adsPrptyTypeCode} className='flex flex-col'
                >
                    <Radio value={1} >آپارتمان مسکونی</Radio >
                    <Radio value={2} >آپارتمان اداری</Radio >
                    <Radio value={3} >خانه و ویلا</Radio >
                    <Radio value={4} >زمین کلنگی</Radio >
                    <Radio value={5} >مستغلات</Radio >
                    <Radio value={6} >مغازه</Radio >
                    <Radio value={7} >صنعتی و کشاورزی</Radio >
                </Radio.Group >
        },

    ];


    const handleCollapseChange = (key) => {
        if (!isProvinceCityLocked) {
            // If clicking on the currently active one, close it
            if (activeKey === key) {
                setActiveKey(null);
            } else {
                setActiveKey(key);
            }
        }
    };
    const handleCollapseChange2 = (key) => {
        if (!isCategoryTradeTypeLocked) {
            // If clicking on the currently active one, close it
            if (activeKey === key) {
                setActiveKey(null);
            } else {
                setActiveKey(key);
            }
        }
    };







    return (
        <div>
            <div className='text-center text-2xl'> ایجاد آگهی ها</div>
            

            <div className="flex flex-col mb-24 mt-3">
                <span className="font-bold text-[16px]">عکس 1 از 9</span>
                <div className="grid grid-cols-9 gap-4 py-2 fiscal ">
                    <div className="relative ">
                        <label className="file-input__label " htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg1("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {



                                        localStorage.setItem(
                                            "img1",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg1(URL.createObjectURL(e.target.files[0]));
                                        setImg1Binary(e.target.files[0]);
                                        // imgList.push(e.target.files[0].name);
                                        imgList.push(e.target.files[0]);




                                    }
                                }}
                                className="file-input__input "
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img1}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg2("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img2",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg2(URL.createObjectURL(e.target.files[0]));
                                        setImg2Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img2}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg3("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img3",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg3(URL.createObjectURL(e.target.files[0]));
                                        setImg3Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img3}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg4("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img4",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg4(URL.createObjectURL(e.target.files[0]));
                                        setImg4Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img4}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg5("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img5",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg5(URL.createObjectURL(e.target.files[0]));
                                        setImg5Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img5}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg6("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img6",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg6(URL.createObjectURL(e.target.files[0]));
                                        setImg6Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img6}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg7("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img7",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg7(URL.createObjectURL(e.target.files[0]));
                                        setImg7Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img7}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg8("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img8",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg8(URL.createObjectURL(e.target.files[0]));
                                        setImg8Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img8}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                    <div className="relative">
                        <label className="file-input__label" htmlFor="pic-personli">
                            <input
                                type="file"
                                name="pic-personli"
                                id=""
                                className="file-input__input "
                                onChange={async (e) => {
                                    if (e.target.files[0].type == "video/mp4") {
                                        if (mp4Count < 3) {
                                            setMp4Count(mp4Count + 1);
                                            setImg9("/Group.svg");
                                        } else {
                                            openNotification();
                                        }
                                    } else {
                                        localStorage.setItem(
                                            "img9",
                                            URL.createObjectURL(e.target.files[0])
                                        );
                                        setImg9(URL.createObjectURL(e.target.files[0]));
                                        setImg9Binary(e.target.files[0]);
                                        imgList.push(e.target.files[0]);
                                    }
                                }}
                            />
                            <img
                                className="absolute w-[100px] h-[72px] rounded"
                                src={img9}
                                alt="انتخاب عکس"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <div className='flex justify-between items-center my-3 gap-5'>
                <div className='w-1/2'>
                    <div className="flex items-center gap-1">
                        <Checkbox
                            checked={isProvinceCityLocked}
                            onChange={(e) => {
                                const isChecked = e.target.checked;
                                if (selectedProvince !== 0 && selectedCity !== 0) {
                                    setIsProvinceCityLocked(isChecked);
                                }
                                if (isChecked) {
                                    if (selectedProvince !== 0 && selectedCity !== 0) {
                                        const newLockedLocation = {
                                            provinceId: selectedProvince,
                                            cityId: selectedCity,
                                        };
                                        setLockedLocation(newLockedLocation);
                                        localStorage.setItem('lockedLocation', JSON.stringify(newLockedLocation));
                                        localStorage.setItem('isProvinceCityLocked', isChecked);
                                    } else {
                                        setChooseProvinceAndCityError(true)
                                    }

                                } else {
                                    setIsProvinceCityLocked(false)
                                    setLockedLocation({ provinceId: null, cityId: null });
                                    localStorage.removeItem('lockedLocation');
                                    localStorage.setItem('isProvinceCityLocked', false);
                                }


                            }}
                        />
                        <span>قفل استان و شهر</span>
                        {/* {lockedLocation} */}

                    </div>
                    {chooseProvinceAndCityError && <div className='text-red-800 text-[12px] '>ابتدا استان و شهر را انتخاب کنید</div>}
                </div>
                <div className='w-1/2'>
                    <div className="flex items-center gap-1">
                        <Checkbox
                            checked={isCategoryTradeTypeLocked}
                            onChange={(e) => {
                                const isChecked = e.target.checked;
                                if (adsMainCategoryCode && adsPrptyTradeTypeCode && adsPrptyTypeCode) {
                                    setIsCategoryTradeTypeLocked(isChecked);

                                    if (isChecked) {
                                        const dataToLock = {
                                            adsMainCategoryCode,
                                            adsPrptyTradeTypeCode,
                                            adsPrptyTypeCode,
                                        };

                                        setLockedCategoryTradeType(dataToLock);
                                        localStorage.setItem('lockedCategoryTradeType', JSON.stringify(dataToLock));
                                        localStorage.setItem('isCategoryTradeTypeLocked', true);
                                    } else {
                                        setLockedCategoryTradeType({
                                            adsMainCategoryCode: null,
                                            adsPrptyTradeTypeCode: null,
                                            adsPrptyTypeCode: null,
                                        });
                                        localStorage.removeItem('lockedCategoryTradeType');
                                        localStorage.setItem('isCategoryTradeTypeLocked', false);
                                    }
                                } else {
                                    setChooseLockedCategoryTradeTypeError(true)
                                }
                            }}
                        />
                        <span>قفل دسته‌بندی و نوع معامله و نوع ملک</span>
                    </div>
                    {chooseLockedCategoryTradeTypeError && <div className='text-red-800 text-[12px] '>ابتدا دسته بندی، نوع معامله و نوع ملک را انتخاب کنید</div>}
                </div>
            </div>

            <div className='flex justify-between items-center my-3 gap-5'>
                <div className='w-1/2'>

                    <div className='grid grid-cols-3 gap-2 '>


                        {/* <div className='flex  relative col-span-6'> */}
                        <Collapse

                            activeKey={activeKey === '23' ? '23' : null}
                            onChange={() => handleCollapseChange('23')}
                            items={provincesCollapse}
                            className={`collapse-ProductDetails ${isProvinceCityLocked ? 'opacity-50' : ''}`} />

                        <Collapse

                            activeKey={activeKey === '22' ? '22' : null}
                            onChange={() => handleCollapseChange('22')}
                            items={citiesCollapse}
                            className={`collapse-ProductDetails ${isProvinceCityLocked ? 'opacity-50' : ''}`} />


                        {/* <Collapse items={districtsCollapse} activeKey={activeKey} onChange={(key) => setActiveKey(key)} className='w-[350px] ml-1  absolute collapse-ProductDetails' /> */}
                        <div
                            tabIndex={0} // Make the wrapper focusable
                            onFocus={(e) => {
                                if (e.target.tagName !== 'INPUT') { // Prevent triggering if the focus is on the input
                                    if (collapseRef.current) {
                                        collapseRef.current.focus(); // Focus directly on the Collapse header

                                    }
                                }
                            }}
                            onKeyDown={handleKeyPress2} // Open Collapse on Enter/Space
                            className={`relative w-full ml-1 collapse-wrapper focus:outline-2`}
                        >

                            <Collapse
                                activeKey={activeKey}
                                onChange={(key) => setActiveKey(key)}
                                className={`collapse-ProductDetails high-z-index absolute focus:outline-blue-500 focus:bg-blue-300`}
                                items={districtsCollapse.map((item) => ({
                                    ...item,
                                    label: (
                                        <span
                                            tabIndex={-1} // Prevent label itself from being focusable
                                            ref={collapseRef}
                                            className=" "
                                        >
                                            {item.label}
                                        </span>
                                    ),
                                }))}
                            />
                        </div>
                    </div>
                
                </div>            
                <div className='w-1/2'>
                    <div className='grid grid-cols-3 gap-2'>
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                            <Collapse 
                                items={categoriesCollapse} 
                                activeKey={activeKey} 
                                onChange={() => handleCollapseChange2('1')} 
                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                            />
                        </div>
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                            <Collapse 
                                items={adsPrptyTradeTypeCodeCollapse} 
                                activeKey={activeKey} 
                                onChange={() => handleCollapseChange2('2')} 
                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                            />
                            {noPrptyTradeTypeCodeError && <p className='text-sm text-red-800'> نوع معامله نمیتواند خالی باشد</p>}
                        </div>
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                            <Collapse 
                                items={adsPrptyTypeCodeCollapse} 
                                activeKey={activeKey} onChange={() => handleCollapseChange2('3')} 
                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                            />
                            {noAdsPrptyTypeCodeError && <p className='text-sm text-red-800'> نوع ملک نمیتواند خالی باشد</p>}

                        </div>
                    </div>                
                </div>            
            </div>


            <div>


                <div className='grid grid-cols-1 gap-2'>
{/* 
                    <div className="overflow-hidden whitespace-nowrap text-ellipsis col-span-2">
                        <Collapse items={categoriesCollapse} activeKey={activeKey} onChange={() => handleCollapseChange2('1')} className='collapse-ProductDetails' />
                    </div>
                    <div className="overflow-hidden whitespace-nowrap text-ellipsis col-span-2">
                        <Collapse items={adsPrptyTradeTypeCodeCollapse} activeKey={activeKey} onChange={() => handleCollapseChange2('2')} className='collapse-ProductDetails' />
                        {noPrptyTradeTypeCodeError && <p className='text-sm text-red-800'> نوع معامله نمیتواند خالی باشد</p>}
                    </div>
                    <div className="overflow-hidden whitespace-nowrap text-ellipsis col-span-2">
                        <Collapse items={adsPrptyTypeCodeCollapse} activeKey={activeKey} onChange={() => handleCollapseChange2('3')} className='collapse-ProductDetails' />
                        {noAdsPrptyTypeCodeError && <p className='text-sm text-red-800'> نوع ملک نمیتواند خالی باشد</p>}

                    </div>
                     */}
                    <div className=''>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none" htmlFor='adsTitle'>عنوان آگهی</label>
                            <input
                                name='adsTitle'
                                onChange={(e) => handleAdsTitleChange(e.target.value)}
                                value={adsTitle}
                                className="flex-1 outline-none w-full text-black"
                                id='adsTitle'
                            />
                        </div>
                        {noTitleError && <p className='text-sm text-red-800'> عنوان آگهی نمیتواند خالی باشد</p>}
                    </div>
                </div>
                <div className='grid grid-cols-4 gap-2 mt-2 mb-2'>

                    <div className="col-span-1 border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]  z-10">
                        <label className="flex-none"> نام و نام خانوادگی:   </label>
                        <input
                            onChange={(e) => setFullName(e.target.value)}
                            value={fullName}
                            className="flex-1 outline-none w-full text-black"

                        />
                    </div>
                    <div className='col-span-1'>
                        <div className={`${noPhonenumberError ? `border border-red-800` : `border border-[#D1D1D1]`} border border-[#D1D1D1] w-[400px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 rounded`}>
                            <label className="flex-none">  شماره تماس :</label>
                            <input
                                value={newPhoneNumber}
                                onChange={(e) => handleMobilePhoneChange(e.target.value)}
                                onKeyDown={handleKeyPress}
                                className="flex-1 outline-none w-full text-black direction-ltr"

                            />
                            <img src='/icons/green-add.svg' alt='plus icon' className="flex-none cursor-pointer" onClick={handleAddPhoneNumber} />
                        </div>
                        {noPhonenumberError && <p className='text-sm text-red-800'>شماره تماس نمیتواند خالی باشد</p>}
                        {longPhonenumberError && <p className='text-sm text-red-800'>شماره تماس نمیتواند بیشتر از 12 رقم باشد</p>}
                        {/* Display list of phone numbers */}
                        <ul className="space-y-2 ">
                            {phoneNumbers.map((number, index) => (
                                <li
                                    key={index}
                                    className="flex items-center gap-2 border border-[#D1D1D1] p-1 px-2 rounded-small text-base rounded my-1"
                                    onClick={() => setEditIndex(index)}
                                >
                                    {/* Conditional rendering for edit mode */}

                                    <input
                                        value={number}
                                        onChange={(e) => handleEditPhoneNumber(index, e.target.value)}
                                        className="flex-1 outline-none text-black"
                                    />
                                    {/* Delete Button */}
                                    <button
                                        className="text-red-500"
                                        onClick={() => handleRemovePhoneNumber(index)}
                                    >
                                        <img src='/icons/minus.svg' alt='minus' />
                                    </button>
                                </li>
                            ))}
                        </ul>
                        {phoneNumbers?.length ?
                            (
                                <div className='flex flex-1 flex-wrap space-y-1'>
                                    {responseFromAdsMasterByPhoneNumber
                                        // ?.filter(item => item?.id != params?.id)
                                        .map((item) => {
                                            const maxLength = 24; // Define the maximum length for the title
                                            const truncatedTitle =
                                                item?.adsTitle?.length > maxLength
                                                    ? item.adsTitle.substring(0, maxLength) + "..."
                                                    : item.adsTitle;
                                            return (


                                                <div
                                                    key={item.id}
                                                    className="border border-[#D1D1D1]  w-1/2 2xl:w-full p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded">

                                                    <a
                                                        href={`/productDetails/${item.id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className='w-full flex items-center justify-between' >
                                                        {item?.registerStatusCode === 25 && (<span className='text-red-500 text-3xl'>&#x2022;</span>)}
                                                        {item?.registerStatusCode === 23 && (<span className='text-green-500 text-3xl'>&#x2022;</span>)}
                                                        {item?.registerStatusCode === 24 && (<span className='text-amber-500 text-3xl'>&#x2022;</span>)}
                                                        {/* {item?.adsTitle} */}

                                                        <Tooltip title={item?.adsTitle}>
                                                            {truncatedTitle}
                                                        </Tooltip>
                                                        <img src='/icons/arrow-left.svg' alt='arrow' />
                                                    </a>
                                                </div>


                                            )
                                        }
                                        )}
                                </div>
                            )
                            :
                            <></>


                        }
                    </div>
                </div>


                {
                    (adsPrptyCategoryCode !== 7 && adsPrptyCategoryCode !== 8) &&
                    <div className='flex justify-between gap-2'>
                        <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]">
                            <label className="flex-none">    آدرس</label>
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                value={address}
                                className="flex-1 outline-none w-full text-black"

                            />
                        </div>
                        <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-3 max-h-[34px]  ">
                            <label className="flex-none">    پلاک</label>
                            <input
                                onChange={(e) => setParcelNumber(e.target.value)}
                                value={parcelNumber}
                                className="flex-1 outline-none w-full text-black"

                            />
                        </div>


                    </div>
                }










                {/* <p>{adsPrptyCategoryCode}</p> */}

                <div className='grid grid-cols-12 gap-2 my-2'>
                    {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6) &&
                        <div className='grid grid-cols-8 gap-2 col-span-8'>
                            <div className='col-span-4'>
                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]">
                                    <label className="flex-none">قیمت متری</label>
                                    <input
                                        value={FormatPrice(pricePerMeter)}
                                        onChange={(e) => {
                                            let rawValue = convertPersianToEnglish(e.target.value);
                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                            setPricePerMeter(rawValue.replace(/,/g, "")); // Save raw number without commas
                                        }}
                                        className="flex-1 outline-none w-full text-black"
                                    />
                                </div>
                                {pricePerMeter ? (
                                    <p className="px-3 text-[12px] text-green-600">
                                        {Num2persian(pricePerMeter)} تومان
                                    </p>
                                ) : null}
                            </div>

                            <div className='col-span-4'>
                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]">
                                    <label className="flex-none">قیمت کل</label>
                                    <input
                                        value={FormatPrice(totalPrice)}
                                        onChange={(e) => {
                                            let rawValue = convertPersianToEnglish(e.target.value);
                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                            setTotalPrice(rawValue.replace(/,/g, "")); // Save raw number without commas
                                        }}
                                        className="flex-1 outline-none w-full text-black"
                                    />
                                </div>
                                {totalPrice ? (
                                    <p className="px-3 text-[12px] text-green-600">
                                        {Num2persian(totalPrice)} تومان
                                    </p>
                                ) : null}
                            </div>
                        </div>
                    }



                    {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) &&

                        <>
                            <div className='col-span-4'>
                                <div className="  border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                    <label className="flex-none"> ودیعه</label>
                                    <input

                                        value={FormatPrice(deposit)} // Format the displayed value
                                        // onChange={(e) => {
                                        //     const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                        //     setDeposit(rawValue); // Set the raw numeric value in Formik state
                                        // }}
                                        onChange={(e) => {
                                            let rawValue = convertPersianToEnglish(e.target.value);
                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                            setDeposit(rawValue.replace(/,/g, "")); // Save raw number without commas
                                        }}
                                        className="flex-1 outline-none w-full text-black"
                                    />

                                </div>
                                {deposit ? (
                                    <p className="px-3 text-[12px] text-green-600">
                                        {Num2persian(deposit)} تومان
                                    </p>
                                ) : null}
                            </div>

                            <div className='col-span-4'>
                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                    <label className="flex-none">  اجاره</label>
                                    <input

                                        value={FormatPrice(rent)} // Format the displayed value
                                        onChange={(e) => {
                                            // const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                            // setRent(rawValue); // Set the raw numeric value in Formik state

                                            let rawValue = convertPersianToEnglish(e.target.value);
                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                            setRent(rawValue.replace(/,/g, "")); // Save raw number without commas
                                        }}
                                        className="flex-1 outline-none w-full text-black"
                                    />

                                </div>
                                {rent ? (
                                    <p className="px-3 text-[12px] text-green-600">
                                        {Num2persian(rent)} تومان
                                    </p>
                                ) : null}
                            </div>










                        </>}






                    {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 4) &&
                        <div className=' col-span-4 grid gap-2 gap-y-2 grid-cols-3 xl:col-span-9'>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full  xl: " >
                                <label className="flex-none">  متراژ</label>
                                <input

                                    value={metrage} // Format the displayed value
                                    onChange={(e) => {
                                        setMetrage(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />
                                {noMetrageError && <p className='text-sm text-red-800'> متراژ  نمیتواند خالی باشد</p>}

                            </div>

                            <div className="border border-[#D1D1D1] p-1  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                                <label className="flex-none">  تعداد اتاق</label>
                                <input

                                    value={numberOfRooms} // Format the displayed value
                                    onChange={(e) => {
                                        setNumberOfRooms(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                                <label className="flex-none">  عمر بنا  </label>
                                <input

                                    value={lifeOfTheBuilding} // Format the displayed value
                                    onChange={(e) => {
                                        setLifeOfTheBuilding(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                        </div>}

                </div>
                {(adsPrptyCategoryCode !== 8 && adsPrptyCategoryCode !== 10 && adsPrptyCategoryCode !== 11) && (
                    <>
                        <Col>
                            <Checkbox checked={isRenovated} className=" font-bold" onClick={() => setIsRenovated(!isRenovated)} value="5"> بازسازی شده</Checkbox>
                        </Col>
                    </>
                )}

                {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12)
                    &&
                    <div className='grid grid-cols-9'>

                        <Col className='mr-1 text-xl font-bold flex items-center justify-center  pb-6  col-span-1'>
                            <Checkbox checked={abilityToConvert} onChange={() => setAbilityToConvert(!abilityToConvert)} >قابلیت تبدیل</Checkbox>
                        </Col>

                        {abilityToConvert &&

                            <div className='col-span-8 grid gap-2 grid-cols-8 '>

                                <div className='col-span-4'>
                                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]" >
                                        <label className="flex-none"> تبدیل مبلغ  ودیعه</label>
                                        <input

                                            value={FormatPrice(convertingDepositAmount)} // Format the displayed value
                                            onChange={(e) => {
                                                const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                setConvertingDepositAmount(rawValue); // Set the raw numeric value in Formik state
                                            }}
                                            className="flex-1 outline-none w-full text-black"
                                        />

                                    </div>
                                    {convertingDepositAmount ? (
                                        <p className="px-3 text-[12px] text-green-600">
                                            {Num2persian(convertingDepositAmount)} تومان
                                        </p>
                                    ) : null}
                                </div>

                                <div className='col-span-4'>
                                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] " >
                                        <label className="flex-none">  تبدیل مبلغ   اجاره</label>
                                        <input

                                            value={FormatPrice(convertingRentAmount)} // Format the displayed value
                                            onChange={(e) => {
                                                const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                setConvertingRentAmount(rawValue); // Set the raw numeric value in Formik state
                                            }}
                                            className="flex-1 outline-none w-full text-black"
                                        />

                                    </div>
                                    {convertingRentAmount ? (
                                        <p className="px-3 text-[12px] text-green-600">
                                            {Num2persian(convertingRentAmount)} تومان
                                        </p>
                                    ) : null}
                                </div>
                                {abilityToConvertError && <p className='text-sm text-red-800 col-span-8'>   در صورت فعال بودن قابلیت تبدیل این مقادیر نمیتوانند خالی باشند </p>}                            </div>
                        }


                    </div>
                }










                <div className='grid grid-cols-4 gap-2 my-2'>
                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                        <div>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  متراژ زمین </label>
                                <input

                                    value={propertyLandMetarage} // Format the displayed value
                                    onChange={(e) => {
                                        setPropertyLandMetarage(e.target.value)
                                        setNoPropertyLandMetarageError(false)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                            {noPropertyLandMetarageError && <p className='text-sm text-red-800'> متراژ زمین  نمیتواند خالی باشد</p>}
                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  متراژ زیر بنای کل</label>
                            <input

                                value={squareFootageEntireProperty} // Format the displayed value
                                onChange={(e) => {
                                    setSquareFootageEntireProperty(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                    </>}
                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 8 || adsPrptyCategoryCode === 12) && <>
                        {adsPrptyCategoryCode === 8 &&
                            <>
                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                    <label className="flex-none">  متراژ</label>
                                    <input

                                        value={metrage} // Format the displayed value
                                        onChange={(e) => {
                                            setMetrage(e.target.value)
                                            setNoMetrageError(false)

                                        }}
                                        className="flex-1 outline-none w-full text-black"
                                    />

                                </div>
                            </>
                        }

                        {(adsPrptyCategoryCode === 12 || adsPrptyCategoryCode === 8) &&
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none"> عرض ملک</label>
                                <input

                                    value={propertyWidth} // Format the displayed value
                                    onChange={(e) => {
                                        setPropertyWidth(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                        }

                    </>}
                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none"> عمر بنا  </label>
                            <input

                                value={lifeOfTheBuilding} // Format the displayed value
                                onChange={(e) => {
                                    setLifeOfTheBuilding(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>

                    </>}

                </div>

                <div className='grid grid-cols-6 gap-2'>
                    {
                        (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2) &&
                        <div className='col-span-3 grid grid-cols-6 gap-2 xl:mb-2'>
                            <div className="col-span-3 border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  طبقه چندم از   </label>
                                <input

                                    value={floorFrom} // Format the displayed value
                                    onChange={(e) => {
                                        setFloorFrom(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>

                            <div className="col-span-3 border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  تعداد کل طبقات </label>
                                <input

                                    value={floorTo} // Format the displayed value
                                    onChange={(e) => {
                                        setFloorTo(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                        </div>
                    }

                    {(adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                        <>


                            <div className="border border-[#D1D1D1] p-1 px-2  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  تعداد طبقات ساختمان</label>
                                <input

                                    value={floorTo} // Format the displayed value
                                    onChange={(e) => {
                                        setFloorTo(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>

                        </>}
                    {
                        (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                        <div className='col-span-1 '>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  واحد در طبقه   </label>
                                <input

                                    value={unitPerFloor} // Format the displayed value
                                    onChange={(e) => {
                                        setUnitPerFloor(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                        </div>
                    }
                </div>



                {
                    (adsPrptyCategoryCode === 10) &&
                    <div className='grid grid-cols-2 gap-2 my-2'>
                        <div>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  قیمت از  </label>
                                <input

                                    value={buyPriceFrom} // Format the displayed value
                                    onChange={(e) => {
                                        setBuyPriceFrom(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                            {buyPriceFrom ? (
                                <p className="px-3 text-[12px] text-green-600">
                                    {Num2persian(buyPriceFrom)} تومان
                                </p>
                            ) : null}
                        </div>
                        <div>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  قیمت تا  </label>
                                <input

                                    value={buyPriceTo} // Format the displayed value
                                    onChange={(e) => {
                                        setBuyPriceTo(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                            {buyPriceTo ? (
                                <p className="px-3 text-[12px] text-green-600">
                                    {Num2persian(buyPriceTo)} تومان
                                </p>
                            ) : null}
                        </div>
                    </div>
                }
                {
                    (adsPrptyCategoryCode === 11) &&
                    <div className='grid grid-cols-4 my-2 gap-2'>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  ودیعه از  </label>
                            <input

                                value={rentDepositFrom} // Format the displayed value
                                onChange={(e) => {
                                    setRentDepositFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  ودیعه تا  </label>
                            <input

                                value={rentDepositTo} // Format the displayed value
                                onChange={(e) => {
                                    setRentDepositTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>


                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  اجاره از  </label>
                            <input

                                value={rentPriceFrom} // Format the displayed value
                                onChange={(e) => {
                                    setRentPriceFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  اجاره تا  </label>
                            <input

                                value={rentPriceTo} // Format the displayed value
                                onChange={(e) => {
                                    setRentPriceTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                    </div>
                }
                {
                    (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) &&
                    <div className='grid grid-cols-4 gap-2'>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  متراژ از  </label>
                            <input

                                value={metrageFrom} // Format the displayed value
                                onChange={(e) => {
                                    setMetrageFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  متراژ تا  </label>
                            <input

                                value={meterageTo} // Format the displayed value
                                onChange={(e) => {
                                    setMeterageTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none"> عمر بنا از</label>
                            <input

                                value={lifeOfBuildingFrom} // Format the displayed value
                                onChange={(e) => {
                                    setLifeOfTheBuildingFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">   تا  </label>
                            <input

                                value={lifeOfBulidingTo} // Format the displayed value
                                onChange={(e) => {
                                    setLifeOfTheBuildingTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black"
                            />

                        </div>



                    </div>
                }



                <div className="flex w-1/6 justify-between border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474]  items-center flex-wrap gap-2 max-h-[34px] rounded my-4" onClick={() => setIsAdsDetailVisible(true)}>
                    جزئیات آگهی
                    <img src='/icons/arrow-back-simple.svg' alt='' />
                </div>

                <Row className=' w-full col-span-6'>
                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                        <Checkbox checked={parking} onClick={() => setParking(!parking)} value="1">پارکینگ</Checkbox>
                    </Col>
                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                        <Checkbox checked={basement} onClick={() => setBasement(!basement)} value="2">انباری</Checkbox>
                    </Col>
                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                        <Checkbox checked={elevator} onClick={() => setElevator(!elevator)} value="3">آسانسور</Checkbox>
                    </Col>
                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                        <Checkbox checked={balcony} onClick={() => setBalcony(!balcony)} value="4">بالکن</Checkbox>
                    </Col>
                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                        <Checkbox checked={isApproximateArea} onClick={() => setIsApproximateArea(!isApproximateArea)} className='whitespace-nowrap'>نمایش محدوده آگهی</Checkbox>
                    </Col>
                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 12) &&
                        <>
                            <Col className='tracking-wide text-xl font-bold flex items-center justify-center ml-1'>
                                <Checkbox checked={officialDeed} onClick={() => setOfficialDeed(!officialDeed)} value="3">سند اداری </Checkbox>
                            </Col>
                        </>
                    }

                </Row>
                <div className='grid grid-cols-2 gap-2 lg:flex lg:flex-col '>
                    <div className='mt-2 h-full'>
                        <label>توضیحات</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={8}
                            className='w-full border border-[#D1D1D1] outline  outline-[#D1D1D1] rounded ' />
                    </div>
                    <MapWithSingleMarker
                        position={

                            []
                        }
                        routing="false"
                        zoom="13"
                        onMapClick={handleMapClick}
                        selectedAreaId={selectedAreaId}
                        selectedProvinceId={selectedProvinceId}
                        selectedCityId={selectedCityId}
                        isInCreateAdPage={true}
                        centerLatitude={areaCenterLatitude}
                        centerLongitude={areaCenterLongitude}
                    />
                </div>
            
                {formErrors.length > 1000000 && (
                <div className='form-errors-wrapper mt-3'>
                        <div className='bg-red-200 text-red-700 p-2 inline'>
                            { formErrors.length}
                            alf oieuro wieruoiu 
                            <ul>
                                {formErrors.map((error) => (
                                    <li> {error} </li>
                                ))}
                            </ul>
                        </div>
                </div>
                )}

                <div className='w-full flex items-center justify-center my-8 mt-24'>
                    <button type='submit' onClick={handleSubmit} className='rounded py-1 px-12 bg-green-900 text-white w-max'>
                        ثبت آگهی
                    </button>
                </div>
            </div >
            <Modal title="جزئیات بیشتر " open={isAdsDetailVisible} onCancel={() => setIsAdsDetailVisible(false)} footer={false}>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded mt-4 mb-2">
                    <label className="flex-none"> جهت ساختمان:  </label>
                    <input
                        onChange={(e) => setBuildingOrientation(e.target.value)}
                        value={buildingOrientation}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> جنس کف:  </label>
                    <input
                        onChange={(e) => setFloorMaterial(e.target.value)}
                        value={floorMaterial}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none">سرویس بهداشتی:  </label>
                    <input
                        onChange={(e) => setBathroomType(e.target.value)}
                        value={bathroomType}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> سرمایش:  </label>
                    <input
                        onChange={(e) => setCoolingSystem(e.target.value)}
                        value={coolingSystem}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> گرمایش:  </label>
                    <input
                        onChange={(e) => setHeatingSystem(e.target.value)}
                        value={heatingSystem}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none">تأمین‌کننده آب گرم:   </label>
                    <input
                        onChange={(e) => setWaterHeaterType(e.target.value)}
                        value={waterHeaterType}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> سند:  </label>
                    <input
                        onChange={(e) => setDeed(e.target.value)}
                        value={deed}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
            </Modal>
        </div >
    )
}
